import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import ContextualHelpDialog from 'bundles/program-loggedin-shared/components/ContextualHelpDialog';

import _t from 'i18n!nls/degree-home';

const EstimatedGraduationDialog = () => {
  return (
    <ContextualHelpDialog
      ariaLabel={_t('View disclaimer')}
      label={
        <Typography2 variant="bodyPrimary" component="span">
          {_t('How dates are calculated')}
        </Typography2>
      }
      dialogHeading={_t('How dates are calculated')}
    >
      <Typography2 component="p">{_t('The estimated graduation date is based on your graduation plan.')}</Typography2>
      <Typography2 component="p">
        {_t(
          'If the graduation plan is incomplete, dates are calculated by dividing the remaining credits needed for graduation by the recommended number of credits required to reach full time status.'
        )}
      </Typography2>
    </ContextualHelpDialog>
  );
};

export default EstimatedGraduationDialog;
